(function () {
  'use strict';

  var config = {
    storageMode: 'immediate',
    retentionDays: 90,
    storageKey: 'burotic_first_touch_attribution',
    cookieName: 'burotic_first_touch_attribution',
    targetPaths: [
      '/pages/business-bulk-prices',
      '/fr/pages/business-bulk-prices'
    ]
  };

  var trackedParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'gclid'
  ];

  var contactFields = [
    'lead_source',
    'lead_source_detail',
    'landing_page',
    'first_touch_date',
    'last_touch_source',
    'submitted_page'
  ];

  function nowIso() {
    return new Date().toISOString();
  }

  function expiresAt() {
    return Date.now() + config.retentionDays * 24 * 60 * 60 * 1000;
  }

  function clamp(value, maxLength) {
    if (typeof value !== 'string') {
      return '';
    }

    return value.trim().slice(0, maxLength || 500);
  }

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getCookie(name) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < cookies.length; i += 1) {
      var parts = cookies[i].split('=');

      if (parts.shift() === name) {
        return decodeURIComponent(parts.join('='));
      }
    }

    return '';
  }

  function setCookie(name, value) {
    var maxAge = config.retentionDays * 24 * 60 * 60;

    document.cookie = [
      name + '=' + encodeURIComponent(value),
      'max-age=' + maxAge,
      'path=/',
      'SameSite=Lax'
    ].join('; ');
  }

  function getStoredAttribution() {
    var stored = '';

    try {
      stored = window.localStorage.getItem(config.storageKey);
    } catch (error) {
      stored = '';
    }

    var attribution = safeParse(stored) || safeParse(getCookie(config.cookieName));

    if (!attribution || !attribution.expires_at || attribution.expires_at < Date.now()) {
      return null;
    }

    return attribution;
  }

  function storeAttribution(attribution) {
    var value = JSON.stringify(attribution);

    try {
      window.localStorage.setItem(config.storageKey, value);
    } catch (error) {
      setCookie(config.cookieName, value);
      return;
    }

    setCookie(config.cookieName, value);
  }

  function getPagePath() {
    return clamp(window.location.pathname + window.location.search, 1000);
  }

  function isTargetPage() {
    return config.targetPaths.indexOf(window.location.pathname) !== -1;
  }

  function getCurrentTouch() {
    var params = new URLSearchParams(window.location.search);
    var touch = {
      captured_at: nowIso(),
      landing_page: getPagePath(),
      original_referrer: clamp(document.referrer, 1000)
    };
    var hasAttributionSignal = false;

    trackedParams.forEach(function (param) {
      var value = clamp(params.get(param), 500);
      touch[param] = value;

      if (value) {
        hasAttributionSignal = true;
      }
    });

    if (touch.original_referrer && !isInternalReferrer(touch.original_referrer)) {
      hasAttributionSignal = true;
    }

    touch.lead_source = classifyLeadSource(touch);
    touch.lead_source_detail = buildLeadSourceDetail(touch);

    return hasAttributionSignal ? touch : null;
  }

  function isInternalReferrer(referrer) {
    try {
      return new URL(referrer).hostname === window.location.hostname;
    } catch (error) {
      return false;
    }
  }

  function classifyLeadSource(touch) {
    var source = (touch.utm_source || '').toLowerCase();
    var medium = (touch.utm_medium || '').toLowerCase();
    var referrer = (touch.original_referrer || '').toLowerCase();

    if (source.indexOf('facebook') !== -1 || source === 'fb' || touch.fbclid || referrer.indexOf('facebook.com') !== -1 || referrer.indexOf('instagram.com') !== -1) {
      return medium.indexOf('paid') !== -1 || medium === 'cpc' || medium === 'social_paid' || medium === 'paid_social' ? 'Facebook Ads' : 'Facebook / Instagram';
    }

    if (source.indexOf('google') !== -1 || touch.gclid) {
      return medium === 'cpc' || medium.indexOf('paid') !== -1 || touch.gclid ? 'Google Ads' : 'Google';
    }

    if (referrer.indexOf('google.') !== -1) {
      return 'Google Organic';
    }

    if (source) {
      return touch.utm_medium ? touch.utm_source + ' / ' + touch.utm_medium : touch.utm_source;
    }

    if (touch.original_referrer) {
      try {
        return 'Referral / ' + new URL(touch.original_referrer).hostname;
      } catch (error) {
        return 'Referral';
      }
    }

    return 'Direct / Internal';
  }

  function buildLeadSourceDetail(touch) {
    var details = [];

    if (touch.utm_source) {
      details.push('source=' + touch.utm_source);
    }

    if (touch.utm_medium) {
      details.push('medium=' + touch.utm_medium);
    }

    if (touch.utm_campaign) {
      details.push('campaign=' + touch.utm_campaign);
    }

    if (touch.utm_content) {
      details.push('content=' + touch.utm_content);
    }

    if (touch.utm_term) {
      details.push('term=' + touch.utm_term);
    }

    return details.join(' | ');
  }

  function updateAttribution() {
    if (config.storageMode !== 'immediate') {
      return getStoredAttribution();
    }

    var currentTouch = getCurrentTouch();
    var stored = getStoredAttribution();
    var attribution = stored || {
      first_touch: currentTouch || {
        captured_at: nowIso(),
        landing_page: getPagePath(),
        original_referrer: clamp(document.referrer, 1000),
        lead_source: 'Direct / Internal',
        lead_source_detail: ''
      }
    };

    if (currentTouch) {
      attribution.last_touch = currentTouch;
    } else if (!attribution.last_touch) {
      attribution.last_touch = attribution.first_touch;
    }

    attribution.expires_at = expiresAt();
    storeAttribution(attribution);

    return attribution;
  }

  function getFieldValue(attribution, fieldName) {
    var firstTouch = attribution && attribution.first_touch ? attribution.first_touch : {};
    var lastTouch = attribution && attribution.last_touch ? attribution.last_touch : firstTouch;

    if (fieldName === 'landing_page') {
      return getPathOnly(firstTouch.landing_page || '');
    }

    if (fieldName === 'first_touch_date') {
      return firstTouch.captured_at || '';
    }

    if (fieldName === 'last_touch_source') {
      return lastTouch.lead_source || '';
    }

    if (fieldName === 'submitted_page') {
      return window.location.pathname;
    }

    return firstTouch[fieldName] || '';
  }

  function getPathOnly(path) {
    return clamp(path.split('?')[0], 1000);
  }

  function ensureHiddenInput(form, fieldName) {
    var selector = 'input[name="contact[' + fieldName + ']"]';
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + fieldName + ']';
      input.setAttribute('data-lead-attribution-field', fieldName);
      form.appendChild(input);
    }

    return input;
  }

  function populateForm(form, attribution) {
    contactFields.forEach(function (fieldName) {
      var input = ensureHiddenInput(form, fieldName);
      input.value = getFieldValue(attribution, fieldName);
    });
  }

  function isContactForm(form) {
    return Boolean(form.querySelector('[data-lead-attribution-form]'));
  }

  function populateContactForms(attribution) {
    var forms = document.querySelectorAll('form');

    forms.forEach(function (form) {
      if (!isContactForm(form)) {
        return;
      }

      populateForm(form, attribution);

      form.addEventListener('submit', function () {
        populateForm(form, updateAttribution() || attribution);
      });
    });
  }

  function init() {
    var attribution = updateAttribution();

    if (!attribution || !isTargetPage()) {
      return;
    }

    populateContactForms(attribution);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
